export default () => {

    let topFilterForm = $('.js-course-grid-filter');
    let sideFilterForm = $('[name="learndash_course_grid_filter"]');
    let searchForm = $('.search-form');

    let selectedCategories = [];
    sideFilterForm.find('.term input[checked]').each(function() {
        selectedCategories.push(this.value);
    });

    //Course Filter Bar

    topFilterForm.submit(function(e){
        e.preventDefault();
        setCourseGridFilter();
    });

    topFilterForm.find('select').change(function(){
        setCourseGridFilter();

        setSelectedCategories();
    });

    $('.learndash-course-grid-filter .btn-clear-filter').click(function(e){
        e.preventDefault();

        if ( $(this).parents('form').hasClass('js-course-grid-filter') ) {
            topFilterForm.find('select').each(function(){
                $(this).val([]);
            });
            topFilterForm.find('select option').each(function(){
                $(this).prop('selected', false);
                $(this).removeAttr('selected');
            });
            topFilterForm.find('.amsify-list-item.active').each(function(){
                $(this).removeClass('active');
            });
            topFilterForm.find('.list-tags').html('');
            topFilterForm[0].reset();
            sideFilterForm.find('.clear').trigger('click');
            testAjaxCourseLoad();
        }

        if ( $(this).parents('form').hasClass('search-form') ) {
            searchForm.find('select').each(function(){
                $(this).val([]);
            });
            searchForm.find('select option').each(function(){
                $(this).prop('selected', false);
                $(this).removeAttr('selected');
            });
            searchForm.find('.amsify-list-item.active').each(function(){
                $(this).removeClass('active');
            });
            searchForm.find('.list-tags').html('');
            searchForm.find('input.form-control').each(function(){
                $(this).val('');
                $(this).attr('value', '')
            });
            searchForm[0].reset();
            searchForm.trigger('submit');
        }

        setSelectedCategories();

    });

    $(document).on('click', '.learndash-course-grid .load-more', function(){
        testAjaxCourseLoad();
    });

    //Search page

    searchForm.find('select').change(function(){
        $(this).parents('form').trigger('submit');
    });

    // Add to Wishlist

    $(document).on('click', '.link-add-wishlist',function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        addToWishlist($(this));
        if ($(this).parents('.section-wishlist').length) {
            $('.loader').show();
            setTimeout(function(){
                location.reload();
            }, 2000);
        }
    });

    // Load Wishlist

    let wishlistPage = 1;

    $('.js-load-wishlist').click(function(e) {
        e.preventDefault();
        wishlistPage += 1;
        loadWishlistItem($(this));
    });


    function loadWishlistItem(el) {
        let $parent = el.parents('.section-wishlist').find('.block-wishlist');
        let $query = $parent.data('query');
        $query.page = wishlistPage;
        $('.loader').show();
        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'load_wishlist_item',
                query: $query
            },
            success(data) {
                $parent.append(data.content);
                if ( $query.page * $query.numberposts >= $query.foundposts  ) {
                    el.parent().hide();
                }
            },
            complete: function(){
                $('.loader').hide();
            },
        });
    }

    function addToWishlist(el) {
        let postId = el.data('id');
        let wishlistEvent = ( el.hasClass('active') ? 'add' : 'remove' );
        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'add_to_wishlist',
                post_id: postId,
                event: wishlistEvent,
            },
            success(data) {},
            complete: function(){},
        });
    }

    function setCourseGridFilter(){
        sideFilterForm.find('[name="search"]').val(topFilterForm.find('[name="search"]').val());

        sideFilterForm.find('.term').find('[type="checkbox"]').each(function(){
            $(this).prop('checked', false);
        });

        topFilterForm.find('select').each(function(){
            var $values = $(this).val();
            var $name = $(this).attr('name');
            if ( $values.length ) {
                $.each($values, function(index, value) {
                    sideFilterForm.find('[name="' + $name + '"][value="' + value + '"]').prop('checked', true);
                });
            }
        });

        sideFilterForm.find('.apply').trigger('click');
        testAjaxCourseLoad();
    }

    function testAjaxCourseLoad(){
        $('.loader').show();
        $.ajax({
            url: LearnDash_Course_Grid.ajaxurl,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'ld_cg_apply_filter',
            },
            success(data) {},
            complete: function(){
                setTimeout(function(){
                    $('.loader').hide();
                }, 1000);
            },
        });
    }

    function setSelectedCategories() {
        if ( selectedCategories.length ) {
            topFilterForm.find('.amsify-list-item').each(function(){
                let $value = $(this).find('input').attr('value');
                if ( inArray($value, selectedCategories) ) {
                    if ( !$(this).hasClass('active') ) {
                        $(this).trigger('click')
                    }
                }
            });
        }
    }

    function inArray(value, array) {
        return array.indexOf(value) > -1;
    }

}
